<template lang="pug">
  .container-settle.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/settle") 结算账户管理
          el-breadcrumb-item 富力钱包
    c-box
      c-header-small
        template(slot="left") 
          div 绑定安全手机
          span.txt-tip 用于富力钱包提现时验证账户安全，可以与富慧通帐号绑定的手机号不一致。
      el-form(:model="source",label-position="right",label-width="100px")
        el-row
          el-col(:offset="8", :span="8")
            el-form-item(label="手机号")
              el-input(v-model="source.mobile")
                el-button(slot="append", @click="sendVerifyCode", :disabled="countdown > 0",class="send")
                  template(v-if="!verify_locked") 获取验证码
                  template(v-else) {{ countdown }} s
        el-row
          el-col(:offset="8", :span="8")
            el-form-item(label="验证码")
              el-input(v-model="source.verify_code") 
        el-row
          el-col(:offset="8", :span="8")
            br
            el-form-item(label="")
              el-button(@click="bindNext",type="primary", round, style="width:180px") 下一步
</template>

<script>
export default {
  data() {
    return {
      source: {
        mobile: "",
        settle_account: this.$route.params.settle_account,
        verify_code: "",
        type: 9
      },
      verify_locked: false,
      countdown: -1,
      tunnelInfo: {}
    };
  },
  computed: {},
  methods: {
    bindNext() {
      if (!this.source.verify_code) {
        this.$message({
          type: "error",
          message: `请输入验证码`
        });
        return;
      }
      this.$store
        .dispatch("BIND_SECURITY_PHONE", this.source)
        .then(res => {
          this.$router.push(
            `/wallet/detail/${this.$route.params.settle_account}/${this.$route.params.settle_id}`
          );
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `${code}：${msg}`
          });
        });
    },
    sendVerifyCode() {
      this.$store
        .dispatch("SECURITY_PHONE_VERIFY_CODE", this.source)
        .then(() => {
          this.startCountdown();
          this.$message({
            type: "success",
            message: "验证码已发出，请注意查收"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `验证码发送失败。${code}：${msg}`
          });
        });
    },
    startCountdown() {
      this.countdown = 60;
      this.verify_locked = true;
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.verify_locked = false;
          clearInterval(t);
        }
      }, 1000);
    },
    getTunnelInfo() {
      // 需要先查一下当前的钱包渠道状态
      this.$store
        .dispatch("GET_WALLET_CHANNEL_INFO", this.$route.params.settle_account)
        .then(res => {
          this.tunnelInfo = res;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取钱包失败。${code}：${msg}`
          });
        });
    }
  },
  mounted() {
    this.getTunnelInfo();
  }
};
</script>
<style lang="less">
.el-input-group__append,
.send {
  background: #275aa0;
  color: #fff;
}
</style>
